import { render, staticRenderFns } from "./batchSearch.vue?vue&type=template&id=735a2d8a&scoped=true"
import script from "./batchSearch.vue?vue&type=script&lang=js"
export * from "./batchSearch.vue?vue&type=script&lang=js"
import style0 from "./batchSearch.vue?vue&type=style&index=0&id=735a2d8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735a2d8a",
  null
  
)

export default component.exports